import { configureStore } from '@reduxjs/toolkit';
import { propertySlice } from './apiSlice/property/propertySlice.tsx';
import { tenantSlice } from './apiSlice/tenant/tenantSlice.tsx';
import { userSlice } from './apiSlice/users/userSlice.tsx';
import { invoicingSlice } from './apiSlice/invoicing/invoicingSlice.tsx';
import { unitSlice } from './apiSlice/unit/unitSlice.tsx';
import { communicationSlice } from './apiSlice/communication/communicationSlice.tsx';
import { reportSlice } from './apiSlice/reportsSlice/reportSlice.tsx';
import { subscriptionSlice } from './apiSlice/subscription/subscriptionSlice.tsx';
// import { giftSlice } from './apiSlice/gift/giftSlice';
// import { triviaSlice } from './apiSlice/trivia/subscriptionSlice';


export const makeStore = () => {
  return configureStore({
    reducer: {
      [propertySlice.reducerPath]: propertySlice.reducer,
      [tenantSlice.reducerPath]: tenantSlice.reducer,
      [userSlice.reducerPath]: userSlice.reducer,
      [invoicingSlice.reducerPath]: invoicingSlice.reducer,
      [unitSlice.reducerPath]: unitSlice.reducer,
      [communicationSlice.reducerPath]: communicationSlice.reducer,
      [reportSlice.reducerPath]: reportSlice.reducer,
      [subscriptionSlice.reducerPath]: subscriptionSlice.reducer,
    //   [triviaSlice.reducerPath]: triviaSlice.reducer,


    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(propertySlice.middleware)
        .concat(tenantSlice.middleware)
        .concat(userSlice.middleware)
        .concat(invoicingSlice.middleware)
        .concat(unitSlice.middleware)
        .concat(communicationSlice.middleware)
        .concat(reportSlice.middleware)
        .concat(subscriptionSlice.middleware)
        // .concat(triviaSlice.middleware)
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
